export default __webpack_public_path__ + "static/media/kid17.931e396b.jpg";